import request from '@/utils/request'

export function getBookingBalance(id) {
  return request({
    url: `/booking-service/v1/deposit/${id}`,
    method: 'get'
  })
}
export function getBookingBalanceGroup(id) {
  return request({
    url: `/booking-service/v1/booking-group-remainder/${id}`,
    method: 'get'
  })
}

export function getGroupDepositAmount(id) {
  return request({
    url: `/booking-service/v1/group-deposit/${id}`,
    method: 'get'
  })
}
